import { graphql } from '@/gql';
import { CallActionEnum, type CallAction } from '@/models/callLog';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const createOperatorCallAction = async (callLogId: number, action: CallActionEnum): Promise<CallAction> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateOperatorCallAction($callLogId: Float!, $action: CallActionTypeEnum!) {
        createOperatorCallAction(callLogId: $callLogId, action: $action) {
          callLogId
          userId
          userName
          userType
          action
          createdAt
        }
      }
    `),
    variables: {
      callLogId,
      action,
    },
  });

  return response.data!.createOperatorCallAction;
};
